import { CHANGE_ACTIVE_ARTWORK } from '../constants/artworkConstants';

export const changeActiveArtwork = (payload) => ({ type: CHANGE_ACTIVE_ARTWORK, payload });
